// ANKHARA site configuration — update event details and links here (or via /admin once live).
export const SITE = {
  name: "ANKHARA",
  tagline: "SWEAT. SPIRIT. SOUND.",
  description:
    "A community-centered DJ series moving through global club sounds, art and the physical language of the dancefloor.",
  soundLine:
    "BRAZILIAN FUNK — AFROBEATS — DANCEHALL — GQOM — JERSEY CLUB — REGGAETON — AMAPIANO — SOCA — BOUYON — ELECTRONIC — GLOBAL CLUB",
  instagramUrl: "https://www.instagram.com/ankhara.world",
  event: {
    title: "ANKHARA SESSIONS: 004",
    date: "Wednesday, November 4, 2026",
    time: "10 PM – 4 AM",
    startIso: "2026-11-04T22:00:00-05:00",
    endIso: "2026-11-05T04:00:00-05:00",
    venue: "Pianos Main Bar — 158 Ludlow St, New York, NY 10002",
    age: "21+",
    entry: "Free RSVP",
    rsvpLabel: "RSVP FOR SESSION 004",
    blurb:
      "Session 004 lands at Pianos on the Lower East Side. Six hours, one room — come early, stay for the progression.",
    // Update the RSVP ticket link here:
    rsvpUrl:
      "https://posh.vip/e/ankhara-session-004-pianos?u=ankharaworld137&_t=mve69kus&os=web&src=event_page&utm_source=website&utm_medium=button&utm_campaign=sessions004",
    // Second RSVP stamp under the main one — clear nextRsvpUrl in /admin to hide it:
    nextRsvpLabel: "RSVP FOR SESSION 005",
    nextRsvpUrl:
      "https://posh.vip/e/ankhara-session-005-starr-bar?u=ankharaworld137&_t=mve6agk1&os=web&src=event_page&utm_source=website&utm_medium=button&utm_campaign=sessions005",
    // The ADD TO CALENDAR links are generated from the fields above (title/startIso/endIso/venue/rsvpUrl) — no hardcoded link.
  },
  // Second event for the homepage tab switcher — its RSVP link is event.nextRsvpUrl above.
  event2: {
    title: "ANKHARA SESSIONS: 005",
    date: "Thursday, November 12, 2026",
    time: "10 PM – 2 AM",
    startIso: "2026-11-12T22:00:00-05:00",
    endIso: "2026-11-13T02:00:00-05:00",
    venue: "Starr Bar — 214 Starr St, Brooklyn, NY",
    age: "21+",
    entry: "Free RSVP",
    blurb:
      "Session 005 lands at Starr Bar in Bushwick. Four hours, one room — come early, stay for the progression.",
    lineup: "PULPTABOO, JONESY, CAMOMAC, BODMON",
  },
  about:
    "ANKHARA is a community-centered DJ and event series built around sweat, spirit and sound. Through global club music, visual art and the physical language of movement, ANKHARA creates space for discovery, creative exchange and genuine connection.\n\nEach session brings together deliberately curated DJs and multidisciplinary artists to create an environment where the audience is invited to participate—not simply observe.",
  join: {
    heading: "ENTER THE ROOT SYSTEM",
    copy: "Get first access to new sessions, open calls, mixes, visual experiments and invitations from ANKHARA.",
  },
  openCall: {
    heading: "ENTER THE ANKHARA ARCHIVE",
    copy: "Share your work for consideration for future ANKHARA sessions, collaborations and creative programming.",
  },
};
